import React from 'react'
import { Drawer, Text, Stack } from '@mantine/core'

export interface CommentsDrawerProps {
  opened: boolean;
  onClose: () => void;
  /** Slop post id, shoot id, blog id, etc. */
  contentId?: string | null;
  /** e.g. "Slop post", "Shoot" */
  contentLabel?: string;
}

/**
 * Stub drawer for comments (Prompt 3). Wire to real comments API later.
 */
export function CommentsDrawer ({
  opened,
  onClose,
  contentId,
  contentLabel = 'Content'
}: CommentsDrawerProps) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title="Comments"
      position="bottom"
      size="70%"
      padding="md"
      zIndex={400}
    >
      <Stack spacing="sm">
        <Text size="sm" color="dimmed">
          Comments are not available here yet. Open the full post to join the discussion.
        </Text>
        {contentId
          ? (
          <Text size="xs" c="dimmed" ff="monospace">
            {contentLabel} · {contentId}
          </Text>
            )
          : null}
      </Stack>
    </Drawer>
  )
}

export default CommentsDrawer
